module.exports = __webpack_public_path__ + "static/media/GBR Tech Collective Infographic Desktop - GBR Tech -  24-05-2024 C.aae96152.gif";